<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="openExchangeModal" persistent max-width="530px">
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Add Exchange Rate</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeAddExchangeRateModal(), $validator.reset()" class="close"
                  ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="successAlert">
                Exchange rate added successfully
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      label="USD price*"
                      v-model="addExchangeRateData.usd_price"
                      :error-messages="errors.collect('USD price')"
                      v-validate="'required|integer'"
                      data-vv-name="USD price"
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      label="TL price*"
                      v-model="addExchangeRateData.tl_price"
                      :error-messages="errors.collect('TL price')"
                      v-validate="'required|decimal:2'"
                      data-vv-name="TL price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddExchangeRateModal(), $validator.reset()"
                outline
                color="normal"
                >Cancel</v-btn
              >
              <v-btn type="submit" style="height:auto; margin-right: 4%" outline color="success"
                >Add</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'openExchangeModal',
    'closeAddExchangeRateModal',
    'successAlert',
    'addExchangeRateData',
    'exchangeRate'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.exchangeRate()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/exchangeRate/addExchangeRate.vue